import { render } from "./EditOrganizationPromptModal.vue?vue&type=template&id=0f05ddb6&scoped=true"
import script from "./EditOrganizationPromptModal.vue?vue&type=script&lang=js"
export * from "./EditOrganizationPromptModal.vue?vue&type=script&lang=js"

import "./EditOrganizationPromptModal.vue?vue&type=style&index=0&id=0f05ddb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f05ddb6"]])

export default __exports__